import { Component, OnInit, Input } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import {
  // SelectApplicationModal,
  // SelectUserModal,
  // UnitAddModal,
  DepartmentNewModal,
  DepartmentUnitModal,
} from 'src/modules/features/admin/modals';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { EditTccRecordModal } from 'src/modules/features/contractor/modals';
import { CompanyService } from 'src/modules/features/contractor/services';
import { ViewHistoryModal } from 'src/modules/features/contractor/modals/view-history-modal/view-history-modal.component';

@Component({
  selector: 'app-admin-verified-company-row',
  templateUrl: './company-record.component.html',
  styleUrls: ['./company-record.component.scss'],
})
export class VerifiedRowComponent implements OnInit {
  @Input() department: any;
  @Input() isBusinessName: boolean;

  organizationId;
  units: Array<any> = [{ name: 'Sample Unit', description: 'sample desc' }];
  pending: boolean;
  collapseEquipment: boolean = true;
  success;
  error;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'certificateHistoryId',
        op: 'eq',
        data: '',
      },
    ],
  };

  filter: AppFilter = new AppFilter({ sidx: 'dateCreated', rows: 3333 });

  documents: any = [
    {
      title: 'Signed letter of notification',
      author: 'Alimi Ajani',
      dateCreated: new Date(),
    },
    {
      title: 'Signed letter of notification',
      author: 'Alimi Ajani',
      dateCreated: new Date(),
    },
  ];

  constructor(
    private modalService: SuiModalService,
    private companySvc: CompanyService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
  }
  // newUser() {
  // 	this.modalService
  // 		.open(new SelectUserModal('Assign User to Department', '', ModalSize.Tiny))
  // 		.onApprove((payload) => {})
  // 		.onDeny(() => {});
  // }
  toggleEquipment() {
    this.collapseEquipment = !this.collapseEquipment;
    this.collapseEquipment == false ? this.getEquipments() : '';
  }
  getColorForLabel(label: string): string {
    switch (label) {
      case 'PENDING':
        return '#FFAC33';
      case 'DISCARDED':
        return '#E4E5E7';
      case 'VERIFIED':
        return '#5FD3A4';
      case 'UNVERIFIED':
        return '#FB4037';
      default:
        return '#E4E5E7';
    }
  }
  getColorTextForLabel(label: string): string {
    switch (label) {
      case 'DISCARDED':
        return '#505050';
      default:
        return '#FFFFFF';
    }
  }
  getEquipments() {
    this.pending = true;
    this.companySvc
      .getCompanyTccRecord({
        tccId: this.department.organizationTccId,
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe((res: any) => {
        this.pending = false;
        this.units = res.rows;
      });
  }
  // assignApp() {
  // 	this.modalService
  // 		.open(new SelectApplicationModal('Assign Application to Department', '', ModalSize.Tiny))
  // 		.onApprove((payload) => {})
  // 		.onDeny(() => {});
  // }
  onChange(event, equipment) {}
  getApplication() {}
  ngOnInit(): void {
    // this.viewCert();
    // console.log(
    // 	JSON.parse(localStorage.getItem('userData'))['appUser']['organization']['organizationTypeId'][
    // 		'organizationTypeId'
    // 	]
    // );
  }
  editRecord() {
    this.modalService
      .open(
        new EditTccRecordModal(
          'Edit TCC Record',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  delete() {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Record',
          'Are you sure you want to delete this Record?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.pending = true;
        this.companySvc
          .updateCompanyTcc({
            organizationId: this.organizationId,
            id: this.department.organizationTccId,
          })
          .subscribe(
            (res) => {
              this.pending = false;
              this.success =
                'Record removed successfully. You will be notified when your changes are verified';
            },
            (error) => {
              this.pending = false;
              this.error = error.error.errorMessage
                ? error.error.errorMessage
                : error.error
                ? error.error
                : error;
            }
          );
      })
      .onDeny(() => {});
  }

  viewHistory(item: any) {
    this.modalService.open(
      new ViewHistoryModal(
        'View History',
        'OTHER_TCC',
        {
          isPending: false,
        },
        this.organizationId,
        item.changeRequestId
      )
    );
  }
}
